import React from "react";
import styles from "./Features.module.css";
import { PiExamFill } from "react-icons/pi";
import { FaBook } from "react-icons/fa";
import { FaBookOpen } from "react-icons/fa";
import { MdBook } from "react-icons/md";

const features = [
  {
    icon: <PiExamFill width={300}/>,
    title: "ප්‍රායොගික පරීක්ෂණ",
    description:
      "විෂය නිර්දේශයට අදාල සියලුම ප්‍රායෝගික පරීක්ෂණ පන්තිය තුලදීම සිදු කිරීම",
  },
  {
    icon: <FaBook />,
    title: "වාර පරීක්ෂණ පැවැත්වීම",
    description:
      "වාර පරීක්ෂණයන් නියමිත අධීක්ෂණයකින් යුක්තව පවත්වා පිළිතුරු පත්‍ර අධීක්ෂණය කර ප්‍රතිඵල වෙබ් පිටුවේ පල කිරීම හා සාකච්ඡා කිරීම",
  },
  {
    icon: <FaBookOpen />,
    title: "ප්‍රගති සමාලෝචනය",
    description:
      "නව තාක්ෂණික ක්‍රමවේදයන් ඔස්සේ ප්‍රශ්න පත්‍රවල ප්‍රගතිය සමාලෝචනය කර ප්‍රගති වාර්තාවක් ලබාදීම",
  },
  {
    icon: <MdBook />,
    title: "සාමාන්‍ය පෙළ සිසුන් සදහා ප්‍රශ්න පත්‍ර පන්තිය",
    description:
      "10 හා 11 ශ්‍රේණි වල සිසුන් සදහා මධ්‍යස්ථාන 2ක සෑම සතියකට වරක් ප්‍රශ්න පත්‍රයක් ලියවා ප්‍රතිඵeල ලබාදී සාකච්ඡා කිරීම",
  },
];

function Features() {
  return (
    <div
      id="features"
      className={`${styles.container} flex flex-col justify-center items-center`}
    >
      <div className="container mx-auto flex items-center flex-col  my-20">
        <h1 className="text-3xl md:text-5xl font-sinhalaPrimary text-center py-3">
          පන්තියේ සුවිශේෂීතා
        </h1>
        <div className={`${styles.cards} w-fit grid grid-cols-1 sm:grid-cols-2 gap-6`}>
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Features;

const FeatureCard = ({icon, title, description}) => {
  return (
    <div className="flex max-w-[450px] p-6 gap-6 bg-[#ffffff20] md:bg-transparent mx-2">
      {/* Icon Wrapper */}
      <div className={`${styles.icon} flex justify-center items-start text-yellow h-[75px] w-[75px] p-2`}>
      <div className="text-5xl">{icon}</div>
      </div>
      {/* Content Wrapper */}
      <div className="flex flex-col flex-1">
        <div className="text-yellow font-bold text-xl font-sinhalaPrimary">
          {title}
        </div>
        <div className="text-white mt-3 text-lg font-sinhalaPrimary">
          {description}
        </div>
      </div>
    </div>
  );
};
